module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-kansai-3-28ac88e5315b2ac466a70adef7e13748.png";